import { Directive, ElementRef, Renderer2, HostListener, ViewContainerRef } from "@angular/core";

@Directive({
  selector: "[appButtonHover]"
})
export class HoverPopupDirective {
  constructor(private elem: ElementRef, private renderer: Renderer2, public viewContainerRef: ViewContainerRef) {}

  @HostListener("mouseenter") onMouseEnter() {
    var div = document.createElement("div");
    div.innerHTML = `
    <div class="topBar">
        <div class="right-ic">
          <a><span class="icon-edit1"></span></a>
          <a><span class="icon-copy"></span></a>
          <a><span class="icon-delete"></span></a>
        </div>
    </div>`;

    div.id = "headerLogo";
    div.classList.add("headerLogo");
    this.elem.nativeElement.appendChild(div);
  }

  @HostListener("mouseleave") onMouseLeave() { console.log('directive');
    this.elem.nativeElement.removeChild(document.querySelector("#headerLogo"));
  }

}

